// DOCS : https://mui.com/material-ui/getting-started/overview/

import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { theme } from 'styles/theme/theme';
import { ErrorFallback } from './components';
import './i18n';
import Routes from './routes';

/**
 * App Routes (code-split)
 */
// const Routes: React.LazyExoticComponent<() => JSX.Element> = lazy(() => import('./routes'));

/**
 * App Component
 */
const App: React.FC = (): JSX.Element => {
    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>
                    {/* <Suspense fallback={<LoadingContainer />}> */}
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes />
                    </Suspense>
                    <ToastContainer
                        style={{ zIndex: 9999 }}
                        position="top-right"
                        autoClose={5000}
                        newestOnTop
                        draggable={false}
                    />
                    {/* </Suspense> */}
                </ErrorBoundary>
            </ThemeProvider>
        </BrowserRouter>
    );
};

export default App;
